import React, { useEffect, useState } from "react";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { usePermissionGuardRedirect } from "../../../../hooks/usePermissionGuard";
import {
  addEventLandingPage,
  getEventLandingPageDetails,
  getUpcomingEventLandingDropDown,
  updateEventLandingPage,
} from "../../../../services/EventService";
import PermissionsGate from "../../../../utils/permissionGate";
import CSSEditor from "../../../common/CSSEditor";
import { FormField } from "../../../common/FormFields";
import HtmlInputEditor from "../../../common/HtmlInputEditor";

const PageDetails = ({ setHeaderName, setPreviewDomain, setPageId }) => {
  const { subId, subTab } = useParams();
  const history = useHistory();
  const [statusArr, setStatusArr] = useState([]);
  const [headerTypeArr, setHeaderTypeArr] = useState([]);
  const [loading,setLoading] = useState(false)
  const [popupArr, setPopupArr] = useState([]);
  const [brandArr, setBrandArr] = useState([]);
  const [eventData, setEventData] = useState({});
  const [isCss,setIsCss] = useState(false);
  const [renderCKE,setRenderCKE] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getUpcomingEventLandingDropDown();
        setStatusArr(res.data.statusList || []);
        setBrandArr(res.data.brandTemplateList || []);
        setPopupArr(res.data.getPopupList || []);
        setHeaderTypeArr(res.data.headerList || []);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const permissionWbseventlpageview = usePermissionGuardRedirect(["wbseventlpageview"]);

  useEffect(() => {
    if (!permissionWbseventlpageview) {
      return;
    }

    const fetchData = async () => {
      try {
        setRenderCKE(false)
        let res = await getEventLandingPageDetails(subId);
        if(res.status == "200"){

          res.data.Data.brandTemplete = res.data.Data?.brandTemplete?.map(
            (el) => el.brandID
          );
          setEventData(res.data?.Data);
          setHeaderName(res.data?.Data?.PageTitle);
          let brandTemplates = res?.data?.Data?.brandTemplete;
          // create array with all BrandID in brandTemplates (looks like [{brandId: <int>}])
          // let brandIds = brandTemplates.map(item => item.brandID) || [];
          if (brandTemplates) {
            //check if brand_ids contain 1
            if (brandTemplates.includes(1)) {
              localStorage.setItem('previewDomain',"https://next.aie.ac");
                setPreviewDomain('https://next.aie.ac');
            } else if (brandTemplates.includes(4)) {
              localStorage.setItem('previewDomain',"https://next.designcenter.co.za");
                setPreviewDomain('https://next.designcenter.co.za');
            } else if(brandTemplates.includes(3)) {
              localStorage.setItem('previewDomain',"https://next.emendy.co.za");
                setPreviewDomain('https://next.emendy.co.za');
            } else if(brandTemplates.includes(2)) {
              localStorage.setItem('previewDomain',"https://next.learnfast.co.za");
              setPreviewDomain('https://next.learnfast.co.za');
            } else if(brandTemplates.includes(6)) {
              localStorage.setItem('previewDomain',"https://next.cadco.co.za");
              setPreviewDomain("https://next.cadco.co.za");
            }
          }else{
            localStorage.setItem('previewDomain',"https://next.aie.ac");
            setPreviewDomain("https://next.aie.ac");
          }
          localStorage.setItem("headerName", res.data?.Data?.PageTitle);
          localStorage.setItem("pageID", subId);
          setPageId(subId);
          setRenderCKE(true)
        }
      } catch (error) {
          console.error(error);
          setRenderCKE(true)
          if (error.response.data?.message !== "") {
            Swal.fire({
              icon: "Info",
              title: "Info",
              text: "No record found with this id",
            })
            history.push(`/websiteManagement/events/landing_page/table`)
          }
      }
    };
    if (subId && (subTab == "open" || subTab == "update")) {
      fetchData();
    }
  }, [subId, permissionWbseventlpageview]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      PageTitle: eventData?.PageTitle || "",
      Brand: eventData?.brandTemplete || [],
      IsPublished: eventData?.IsPublished,
      ShowTitleInBody: eventData?.ShowTitleInBody || 0,
      BodyContent: eventData?.BodyContent || "",
      SliderID: eventData?.SliderID || "",
      PopupID: eventData?.PopupID || "",
      FormDestinationEmail: eventData?.FormDestinationEmail || "",
      conversion_code: eventData?.conversion_code || "",
      MetaTitle: eventData?.MetaTitle || "",
      MetaDescription: eventData?.MetaDescription || "",
      MetaKeywords: eventData?.MetaKeywords || "",
      addCustomCss: eventData?.addCustomCss || 0,
      customCss: eventData?.customCss || "",
    },
    validationSchema: Yup.object().shape({
      customCss : isCss ? Yup.string().required("Custom Css is required") : "",
      PageTitle: Yup.string().required("Page Title is required"),
      Brand: Yup.array().min(1, "At least one template is required"),
      BodyContent: Yup.string().required("Page Content is required"),
      IsPublished : Yup.number().required("Status is required")
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true)
      try {
        if (subTab == "create") {
          await addEventLandingPage(values);
          setLoading(false)
          Swal.fire(
            "Success!",
            "Landing page created successfully!",
            "success"
          );
          history.push("/websiteManagement/events/landing_page/table");
        } else if (subTab == "open") {
          await updateEventLandingPage({ ...values, PageID: subId });
          setLoading(false)
          Swal.fire(
            "Success!",
            "Landing page updated successfully!",
            "success"
          );
          history.push(`/websiteManagement/events/landing_page/page_details/open/${subId}`);
        }
      } catch (error) {
        Swal.fire(
          "Error!",
          `Failed to ${subTab == "create" ? "create" : "update"} Landing page`,
          "error"
        );
        console.log(error);
      }
      setSubmitting(false);
    },
  });
  const handleEditorChange = (key, value) => {
    formik.setFieldValue(key, value);
  };
  useEffect(() => {
    setIsCss(formik.values?.addCustomCss)
  },[formik.values.addCustomCss])

  return (
    <div className="card card-body-inr">
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-12">
            <div className="edit-icon new-card-header">
              <h4 className="card-header">Page Details</h4>
            </div>
          </div>

          <FormField
            field={{ name: "PageTitle", label: "Page Title" }}
            formik={formik}
          />

          <div className="col-md-6 col-lg-3">
            <label htmlFor="Brand">
              Assigned Brand Templates * <i className="fal fa-info-circle"></i>
            </label>
            <div className="form-icon-group mb-4">
              <Select
                className={`form-control custom-select-box ${formik.touched.Brand && formik.errors.Brand && "is-invalid"
                  }`}
                name="Brand"
                value={brandArr?.filter((val) =>
                  formik.values.Brand?.includes(val.value)
                )}
                onChange={(value) =>
                  formik.setFieldValue(
                    "Brand",
                    value ? value.map((v) => v.value) : []
                  )
                }
                isClearable
                onBlur={formik.handleBlur}
                options={brandArr}
                maxMenuHeight={175}
                placeholder="Select"
                isMulti
              />
            </div>
          </div>

          <FormField
            field={{
              name: "IsPublished",
              label: "Status",
              info: true,
            }}
            isClearable={false}
            // required={false}
            formik={formik}
            selectOptions={statusArr}
          />
          
          <div className="col-md-12">
            <label htmlFor={"disclaimer_tc"}>Page Content *</label>
            <div className="form-icon-group mb-6 laptop-pricing">
              {
                renderCKE && (
                  <HtmlInputEditor
                    editorState={formik.values?.BodyContent}
                    setEditorState={(value) =>
                      handleEditorChange("BodyContent", value)
                    }
                    isInValid={formik.errors.BodyContent}
                    isCKEditor={true}
                    hideSign={true}
                  /> 
                ) 
              }
              {
                !renderCKE && 
               (
                  <HtmlInputEditor
                    editorState={formik.values?.BodyContent}
                    setEditorState={(value) =>
                      handleEditorChange("BodyContent", value)
                    }
                    isInValid={formik.errors.BodyContent}
                    isCKEditor={true}
                    hideSign={true}
                  />
                )
              }
            </div>
          </div>
          <div className="col-md-12">
            <hr
              className="border border-2"
              style={{ borderColor: "#E6EBF1" }}
            />
          </div>
          <div className="col-md-12">
            <div className="edit-icon new-card-header">
              <h4 className="card-header">Page Settings</h4>
            </div>
          </div>

          <FormField
            field={{ name: "SliderID", label: "Header" }}
            formik={formik}
            required={false}
            selectOptions={headerTypeArr}
            col_md={6}
            col_lg={4}
          />

          <FormField
            field={{ name: "PopupID", label: "Popup" }}
            formik={formik}
            required={false}
            selectOptions={popupArr}
            col_md={6}
            col_lg={4}
          />
          {/* According to the latest bugs this form field has been removed */}
          {/* <FormField
            field={{
              name: "FormDestinationEmail",
              label: "Form Email",
              required: false,
            }}
            formik={formik}
            col_md={6}
            col_lg={4}
          /> */}
          <div className="col-md-12">
            <div className="edit-icon new-card-header">
              <h4 className="card-header">
                <FontAwesomeIcon icon={faGear} color="var(--topbar-color)" />{" "}
                SEO Settings
              </h4>
            </div>
          </div>

          <FormField
            field={{
              name: "conversion_code",
              label: "Conversion Code",
            }}
            required={false}
            formik={formik}
          />

          <FormField
            field={{ name: "MetaTitle", label: "Meta Title" }}
            required={false}
            formik={formik}
          />

          <FormField
            field={{
              name: "MetaDescription",
              label: "Meta Description",
            }}
            required={false}
            formik={formik}
          />

          <FormField
            field={{
              name: "MetaKeywords",
              label: "Meta Keywords",
            }}
            required={false}
            formik={formik}
          />
          <div className="col-md-12">
            <div className="edit-icon new-card-header">
              <h4 className="card-header">
                <FontAwesomeIcon icon={faGear} color="var(--topbar-color)" />{" "}
                Style Settings
              </h4>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 d-flex align-items-center mb-3">
            <label className="mb-0">
              Add Custom CSS<i className="fal fa-info-circle"></i>
            </label>
            <div className="toggle-switch ml-2">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={formik.values?.addCustomCss === 1}
                  onChange={(e) =>
                    formik.setFieldValue(
                      "addCustomCss",
                      e.target.checked ? 1 : 0
                    )
                  }
                />
                <span className="slider slider-round"></span>
              </label>
            </div>
          </div>
          {formik.values?.addCustomCss ? (
            
            <div className="col-md-12">
              <div className="form-group-blk mb-3">
              <>
                            <span className="my-2">Custom CSS *</span>
                        <div className="html-editor-input">
                        <CSSEditor 
                         value={formik.values.customCss}
                         onChange={(value) => formik.setFieldValue('customCss', value)}
                         onBlur={formik.handleBlur}
                         className={formik.touched.customCss && formik.errors.customCss ? "is-invalid" : ""}
                         placeholder="Enter CSS code..."
                     />
                        <div className="headerf">
                        <span className="title fw-bolds"> CSS</span>
                        </div>
                        </div>
                        </>
                {/* <label>Customs CSS*</label>
                <HtmlInputEditor
                  editorState={formik.values?.customCss}
                  setEditorState={(value) =>
                    handleEditorChange("customCss", value)
                  }
                  isInValid={formik.errors.customCss}
                  isCKEditor={true}
                  hideSign={true}
                /> */}
              </div>
            </div>
          ) : null}
        </div>
        <div className="form-group form-group-save-cancel mt-4">
          <PermissionsGate scopes={[subTab == "create" ? 'wbseventlpageadd' : 'wbseventlpageedit']} RenderError={() => (
            <button className="btn btn-save btn-success" disabled>
              <i className="fal fa-save"></i> Save
            </button>
          )}>

            <button
              className="btn btn-save btn-success"
              type="submit"
              title="Save"
              disabled={loading}
            >
             {loading ? <i className="fal fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
              Save
            </button>
          </PermissionsGate>
        </div>
        {Object.keys(formik.errors).map((key) => {
          if (formik.touched[key]) {
            return (
              <div className="invalid-feedback d-block" key={key}>
                {formik.errors[key]}
              </div>
            );
          }
          return null;
        })}
      </form>
    </div>
  );
};

export default PageDetails;
